import get from 'lodash.get';

import { getScheduleFeed } from './tve';

// Rearrange order to change rendered order on schedule page.
export const DAYS = new Map([
  [1, 'Monday'],
  [2, 'Tuesday'],
  [3, 'Wednesday'],
  [4, 'Thursday'],
  [5, 'Friday'],
  [6, 'Saturday'],
  [0, 'Sunday'],
]);

/**
 * Formatter utility that accepts the JSON return value of a fetch call to the schedule feeds
 * service. Translates an array of entries into an object whos keys are the days of the week, and
 * values are an object with the required fields for rendering by our custom Schedule package.
 *
 * The values in the object are staggered so each day contains content from 5:00 am for that current
 * day, up until 5:00 am in the next day.
 */
export const formatScheduleFieldsByDay = (entries = []) => entries.reduce((days, entry) => {
  const seriesIdLong = get(entry, 'seriesId') || '';
  const seriesId = seriesIdLong.substr(seriesIdLong.lastIndexOf('/') + 1);
  const formattedEntry = {
    title: get(entry, ['program', 'title']),
    genre: get(entry, ['program', 'displayGenre'], ''),
    startTime: entry.startTime,
    seriesId,
    description: get(entry, ['program', 'description'], ''),
  };
  // Entries earlier than 5:00 am get pushed to the previous day
  const date = new Date(formattedEntry.startTime);
  const hour = date.getHours();
  const dayOffset = hour < 5 ? 1 : 0;
  const numDay = date.getDay() - dayOffset;
  const day = DAYS.get(numDay);

  if (days[day]) {
    days[day].push(formattedEntry);
  } else {
    // eslint-disable-next-line no-param-reassign
    days[day] = [formattedEntry];
  }

  return days;
}, {});

/**
 * Utility function to check if a provided schedule entry has a start time on the next that takes
 * place a day later than the provided previousEntry.
 * Both entries are objects configured by formatScheduleFieldsByDay from this file.
 */
export const entryIsNextDay = (currentEntry, previousEntry) => {
  if (!previousEntry) return false;

  const currentEntryStartTime = get(currentEntry, 'startTime', 0);
  const previousEntryStartTime = get(previousEntry, 'startTime', 0);
  const currentEntryDay = new Date(currentEntryStartTime).getDay();
  const previousEntryDay = new Date(previousEntryStartTime).getDay();

  return currentEntryDay > previousEntryDay;
};

const programmingGuideFields = [
  'guid',
  'startTime',
  'program.title',
  'program.displayGenre',
  'program.description',
  'program.runtime',
  'seriesId',
];

/**
 * Formatter function to create parameters for the existing tve URL formatter function.  Primarily
 * use is generating a range of dates (last Sunday to next Sunday)
 */
export const formatScheduleRequest = (vertical) => {
  const date = new Date(Date.now());
  date.setDate(date.getDate() - date.getDay());
  date.setHours(5);
  const lastSundayMilli = date.getTime();
  date.setDate(date.getDate() + 7);
  const nextSundayMilli = date.getTime();

  return getScheduleFeed({
    vertical,
    fields:
    programmingGuideFields,
    count: 250,
    startTime: lastSundayMilli,
    endTime: nextSundayMilli,
  });
};
